// Discovery Button Markup
// https://guidelines.syte.ai/5c8a9b7e5/p/179c32-discovery-button
import React from 'react';
import Button from '@tcp/core/src/components/common/atoms/Button';

const DiscoveryButton = ({ config, children, ...props }) => {
  if (config?.image?.includes('.mp4') || config?.image?.includes('.gif')) {
    return null;
  }

  const customClasses = props?.customStylesCls;

  return (
    <>
      <Button
        className={`syte-discovery ${customClasses}`}
        onClick={() => {
          config?.clickAnalytics({
            customEvents: ['event102'],
            syte_shop_similar_metrics102: '1',
          });
        }}
        data-image-src={config.image}
        data-sku={config.sku}
        data-placement={config.placement}
        overrideStyle={`background: transparent !important; font-size: 14px; font-family: 'Nunito'; display: flex; margin-left: auto`}
        {...props}
      >
        {children}
      </Button>
    </>
  );
};

export default DiscoveryButton;
